import React, { useState, useRef } from 'react'
import SimpleReactValidator from "simple-react-validator";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function ResetPassword() {
    const [userName, setUserName] = useState("");
    const [, forceUpdate] = useState();
    const validator = useRef(new SimpleReactValidator({
        messages: {
            email: 'Please enter a valid username.'
        },
        autoForceUpdate: { forceUpdate }
    }));

    const handleSubmit = event => {
        if (!validator.current.allValid()) {
            validator.current.showMessages();
            forceUpdate(1);
            return false;
        }
        const request = new Request(`${interfaceConfig.API_URL}/User/ResetPassword?email=${userName}`, {
            method: 'GET',
            headers: new Headers({ 'Content-Type': 'application/json' }),
        });
        fetch(request).then(res => {
            return res.status;
        }).then((status) => {
            if (status === 200) {
                toast.success("Password reset code sent to your email.", { position: toast.POSITION.TOP_LEFT, autoClose: 1500 });
                setUserName("");
                window.location.href = `${interfaceConfig.WEB_URL}/setPassword`;
            } else {
                toast.error("Unable to send reset password email.", {
                    position: toast.POSITION.TOP_LEFT
                });
            }
        }).catch(err => {
            console.log('%c Err', 'font-size:20px;color:red', err);
        })
    };

    return (
        <section className="login_bg reset-pass">
            <ToastContainer />
            <div className="container">
                <div className="col-md-12">
                    <div className="row">
                        <div className="col-lg-4 col-md-3 col-sm-3 col-xs-12"></div>
                        <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                            <div className="login_block">
                                <div className="login_about">
                                </div>
                                <div className="row">
                                    <div className="col-lg-12 col-sm-12">
                                        <div className="form_login">
                                            <div className="form-group">
                                                <div className="col-md-12 text-center">
                                                    <img src="../../../images/logo.png" style={{ width: '120px' }} className="center-block" alt="..." />
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <div className="col-md-12 text-center">
                                                    <h3>Reset Password</h3>
                                                </div>
                                            </div>
                                            <form>
                                                <div className="form-group">
                                                    <div className="col-sm-12">
                                                        <div className="input-group input-group-lg">
                                                            <div className="input-group-addon"  >
                                                                <i className="fa fa-user"></i>
                                                            </div>
                                                            <input type="text" className="form-control"
                                                                value={userName}
                                                                name="userName"
                                                                onChange={e => setUserName(e.target.value)}
                                                                placeholder="Username" />
                                                            <i className="fa fa-question-circle help_icon" data-toggle="tooltip" title="Use your email address" ></i>
                                                        </div>
                                                        {validator.current.message("Username", userName, "required|email")}
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <div className="col-md-12">
                                                        <div className="row">
                                                            <div className="col-sm-12 text-right">
                                                                <button type="button" onClick={handleSubmit} className="btn btn-primary btn-sm">Reset</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <div className="col-md-12">
                                                        <div className="row">
                                                            <div className="col-sm-12">
                                                                <a href="/" >Back To Sign in</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-3 col-sm-3 col-xs-12"></div>
                    </div>
                </div>
            </div>
        </section >
    )
}

export default ResetPassword